import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CityService } from '../../main-layout/city/city.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-citymodal',
  templateUrl: './citymodal.component.html',
  styleUrls: ['./citymodal.component.css']
})
export class CitymodalComponent extends BaseClass implements OnInit {
  CSRFToken='';
  saveTitle = 'Add';
  cityform: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  existingdetails: any = {};
  activeFlag = [
    { labelname: 'Active', value: 'Y' },
    { labelname: 'Inactive', value: 'N' }
  ];

  public validation_message = {
    'name': [
      { type: 'required', message: 'City name is required.' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters not allowed ( % and \' ).' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  };

  constructor(
    private cityService: CityService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice:NgxSpinnerService
  ) {
    super(injector);
    const dataFromParent = this.config.data; 
    this.gettoken();
    if (dataFromParent?.title === 'Modify City') {
      this.isEdit = true;
      this.saveTitle = 'Modify';
      this.existingdetails = dataFromParent.datas;
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0]);
    }
  }

  patchValueForms(data) {
    this.cityform.patchValue({
      'name': data?.name,
      'activeflag': data?.activeflag
    });
  }


  formInitiliaze() {
    this.cityform = this.fb.group({       
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],
      activeflag: ['Y']
    });
  }

  add() { 
    if (this.cityform.invalid) {
      this.validateAllFormFields(this.cityform);
      return; // Exit early if the form is invalid
    }

    if (this.saveTitle === 'Modify') {
      this.modify(this.cityform.value);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.cityform.value;
          data['csrftoken']=this.CSRFToken
          this.spinnerservice.show();  
          // this.cityService.addCity(this.cityform.value).subscribe((data) => {
          //   this.spinnerservice.hide();  
          //   Swal.fire("Saved!", "", "success").then(() => { 
          //     this.ref.close();
          //   });
          // }, error => {
          //   this.spinnerservice.hide();      
          //   Swal.fire("Error!", error.error.response, "error");
          // });
          this.cityService.addCity(data).subscribe({
          next: (response: any) => {                 
            if (response.response === 'exists') {
              this.spinnerservice.hide(); 
              Swal.fire("City already exists!", "", "error").then(() => {                
              });
            } else {
              this.spinnerservice.hide(); 
              Swal.fire("City added successfully!", "", "success").then(() => {
                this.ref.close();
              });
            }
          },
          error: (error) => {  
            Swal.fire({
              title: "Error Saving City",
              text: error.error.message || "An unexpected error occurred.",
              icon: "error",
            });
          },
        });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    }
  }

  modify(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((value) => {
      if (value.isConfirmed) {
        let data = this.cityform.value;
        data['csrftoken']=this.CSRFToken
        data.cityid = this.existingdetails[0].cityid; // Ensure you have the correct ID
        // this.cityService.updateCity(data).subscribe((response) => {
        //   this.spinnerservice.hide();  
        //   Swal.fire("Updated!", "", "success").then(result => {
        //     this.ref.close();
        //   });
        // }, error => {
        //   this.spinnerservice.hide();      
        //   Swal.fire("Error!", error.error.response, "error");
        // });
        this.cityService.updateCity(data).subscribe({
          next: (response: any) => {                 
            if (response.response === 'exists') {
              Swal.fire("City already exists!", "", "error").then(() => {
              });
            } else {
              Swal.fire("City modified successfully!", "", "success").then(() => {
                this.ref.close();
              });
            }
          },
          error: (error) => {    
            Swal.fire({
              title: "Error Saving City",
              text: error.error.message || "An unexpected error occurred.",
              icon: "error",
            });
          },
        });
      } else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }
       gettoken(){
        this.CSRFToken='';
         this.utilityservice.getCSRFtoken().subscribe(res=>{
         this.CSRFToken=res.csrf;
        },error=>{
          Swal.fire(error.error.message,'','error');
        });
      }
}
